<!--
 * @Author       : Lobin
 * @Date         : 2022-06-21 21:24:16
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2022-06-24 16:18:53
-->
<template>
  <div class="search-list">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="用户名">
        <el-input v-model="formInline.username" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="别称">
        <el-input v-model="formInline.nickname" placeholder="别称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="loading">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="btns">
         <el-button type="primary" @click="addUser">添加用户</el-button>
    </div>
    <div class="search-list-data" v-loading="loading">
        <el-table :data="tableData" stripe style="width: 100%" size="medium" border>
            <el-table-column type="index" label="#" width="50">
            </el-table-column>
            <el-table-column prop="nickname" label="别称" width="180">
            </el-table-column>
            <el-table-column prop="username" label="用户名"> </el-table-column>
            <el-table-column prop="role.name" label="角色"> </el-table-column>
            <el-table-column prop="ctime" label="创建时间"> </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="100">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleModifyUser(scope.row)">编辑</el-button>
                <el-button @click="handleDeleteUser(scope.row._id)" type="text" size="small">删除</el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog
        :title="dialogType === 'add' ? '添加用户' : '编辑用户'"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="username">
                <el-input v-model="ruleForm.username" placeholder="输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" v-if="dialogType === 'add'">
                <el-input v-model="ruleForm.password" placeholder="输入密码(密码中必须包含字母、数字和特殊字符)" show-password></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" v-else>
                <el-input v-model="ruleForm.password" placeholder="输入密码(密码中必须包含字母、数字和特殊字符)" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item label="管理员">
                <el-switch v-model="ruleForm.isAdmin"></el-switch>
            </el-form-item>
            <el-form-item label="别称" prop="nickname">
                <el-input v-model="ruleForm.nickname" placeholder="输入别称"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role">
                <el-select v-model="ruleForm.role" placeholder="请选择角色">
                    <el-option :label="role.name" :value="role._id" v-for="role in roleList" :key="role._id">
                        {{ role.name }}
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="submiting">提交</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </el-form-item>
            </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

const passwordReg = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![0-9a-zA-Z]+$)(?![0-9\\W]+$)(?![a-zA-Z\\W]+$)[0-9A-Za-z\\W]{8,18}$');
const validatePass = (rule, value, callback) => {
  if (value.length < 8) {
    callback(new Error('密码长度必须大于等于8位数'));
  } if (!passwordReg.test(value)) {
    callback(new Error('密码中必须包含字母、数字和特殊字符'));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      formInline: {
        username: "",
        nickname: "",
      },
      dialogVisible: false,
      tableData: [],
      dialogType: 'add',
      ruleForm: {
        username: "",
        nickname: "",
        password: "",
        isAdmin: false,
        role: "",
      },
      roleList: [],
      pager: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      loading: false,
      submiting: false,
    };
  },
  computed: {
    rules() {
      const ruleObj = {
        username: { required: true, message: '请输入用户名', trigger: 'blur' },
        nickname: { required: true, message: '请输入别称', trigger: 'blur' },
        role: { required: true, message: '请选择角色', trigger: 'change' },
      };
      if (this.dialogType === 'add') {
        return {
          ...ruleObj,
          password: { required: true, validator: validatePass, trigger: 'change' },
        };
      }
      return ruleObj;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions({
      getAdminUserList: 'user/adminUserList',
      createUser: 'user/createAdminUser',
      modifyUser: 'user/modifyAdminUser',
      deleteUser: 'user/deleteAdminUser',
      getRoleList: 'getRoleList',
    }),
    async getList() {
      this.loading = true;
      const data = await this.getAdminUserList({
        ...this.formInline,
        page: this.pager.page,
      });
      console.log(data);
      this.tableData = data.docs;
      this.pager = {
        page: data.page,
        pageSize: data.limit,
        total: data.total,
      };
      this.loading = false;
    },
    onSubmit() {
      this.getList();
    },
    async addUser() {
      this.dialogType = 'add';
      this.ruleForm = {};
      this.dialogVisible = true;
      this.getRoleData();
    },
    async getRoleData() {
      const roleList = await this.getRoleList();
      this.roleList = roleList;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async handleModifyUser(data) {
      this.dialogVisible = true;
      this.dialogType = 'modify';
      await this.getRoleData();
      this.ruleForm = { ...data };
      // eslint-disable-next-line no-underscore-dangle
      this.ruleForm.role = data.role._id;
    },
    handleDeleteUser(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await this.deleteUser(id);
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
        this.getList();
      });
    },
    async submitForm() {
      this.submiting = true;
      let res;
      if (this.dialogType === 'add') {
        res = await this.createUser(this.ruleForm);
      } else {
        res = await this.modifyUser(this.ruleForm);
      }
      if (res) {
        this.$message.success('提交成功');
        this.getList();
        this.dialogVisible = false;
      }
      this.submiting = false;
    },
  },
};
</script>
<style lang="less" scoped>
.btns {
    margin-bottom: 10px;
}
</style>
